import React, { useEffect } from "react";

import useLayoutStore from "store/useLayoutStore";
import { Error403 } from "container/Error/Error403";
const Error403Page = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <Error403 />
    </>
  );
};

export default Error403Page;
